"use client";

import { useState } from "react";
import { Typography } from "@/components/ui";

interface SpecAccordionItem {
  step: string;
  factor: string;
  detail: string;
}

export function SpecAccordion({ items }: { items: SpecAccordionItem[] }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="flex flex-col gap-5">
      {items.map((row, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={row.factor}
            className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? -1 : idx)}
              className="flex w-full items-center gap-4 cursor-pointer select-none px-6 py-5 hover:bg-gray-50 transition-colors text-left"
              aria-expanded={isOpen}
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent text-xs font-bold">
                {row.step}
              </span>
              <Typography as="h3" variant="h4" className="font-semibold text-text-primary flex-1 min-w-0">
                {row.factor}
              </Typography>
              <svg
                className={`h-4 w-4 shrink-0 text-text-secondary transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              className={`grid transition-[grid-template-rows] duration-200 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
            >
              <div className="overflow-hidden">
                <div className="px-6 pb-6 pt-0">
                  <Typography
                    as="p"
                    variant="body"
                    className="text-sm leading-relaxed text-text-secondary"
                  >
                    {row.detail}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
